import React from 'react';


const LotteryNum = ({num}) => {
  return (
    <div className="flex w-full h-10 justify-center items-center border border-[#0987F3] rounded-lg text-base">
        <p>{num}</p>
    </div>
  );
}

export default LotteryNum;